import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";

const NUMBERS = [
  { label: "Service client 1", number: "+235 64 92 73 80", wa: "23564927380" },
  { label: "Service client 2", number: "+235 92 26 84 75", wa: "23592268475" },
];

const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 z-50 flex flex-col items-end gap-2">
      {open && (
        <div data-testid="whatsapp-popover" className="bg-white border border-neutral-200 rounded-2xl shadow-2xl p-3 w-64 animate-in fade-in slide-in-from-bottom-2">
          <p className="text-xs font-bold uppercase tracking-widest text-neutral-500 mb-2 px-1">Discuter sur WhatsApp</p>
          {NUMBERS.map((n) => (
            <a
              key={n.wa}
              href={`https://wa.me/${n.wa}?text=${encodeURIComponent("Bonjour IMORA Tchad, j'ai une question.")}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`whatsapp-number-${n.wa}`}
              className="flex items-center gap-3 p-2.5 rounded-xl hover:bg-[#25D366]/10 transition"
              onClick={() => setOpen(false)}
            >
              <div className="h-9 w-9 rounded-full bg-[#25D366] text-white flex items-center justify-center shrink-0">
                <MessageCircle className="h-4 w-4" />
              </div>
              <div className="leading-tight">
                <div className="text-sm font-bold">{n.label}</div>
                <div className="text-xs text-neutral-500">{n.number}</div>
              </div>
            </a>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        data-testid="whatsapp-float-btn"
        aria-label="Chat WhatsApp"
        className="h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1EBE5A] text-white shadow-xl flex items-center justify-center transition active:scale-95"
      >
        {open ? <X className="h-6 w-6" /> : (
          <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor">
            <path d="M16.004 3C8.83 3 3 8.83 3 16.004c0 2.29.6 4.53 1.74 6.5L3 29l6.66-1.7a12.96 12.96 0 0 0 6.34 1.66h.01C23.18 28.96 29 23.13 29 15.96 29 8.83 23.17 3 16.004 3zm0 23.6a10.7 10.7 0 0 1-5.45-1.49l-.39-.23-4.05 1.03 1.08-3.94-.25-.4a10.6 10.6 0 0 1-1.63-5.66c0-5.88 4.79-10.66 10.68-10.66 5.88 0 10.66 4.78 10.66 10.66 0 5.89-4.78 10.68-10.65 10.69zm5.86-8c-.32-.16-1.9-.94-2.19-1.05-.29-.1-.5-.16-.72.16-.21.32-.82 1.05-1 1.26-.19.21-.37.24-.69.08-.32-.16-1.36-.5-2.58-1.6-.95-.85-1.6-1.9-1.78-2.22-.19-.32-.02-.5.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.72-1.74-.99-2.38-.26-.63-.53-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66 0 1.57 1.14 3.08 1.3 3.3.16.21 2.25 3.43 5.45 4.81.76.33 1.36.53 1.82.67.77.25 1.46.21 2.01.13.61-.09 1.9-.78 2.16-1.53.27-.75.27-1.39.19-1.53-.08-.13-.29-.21-.61-.37z" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default WhatsAppFloat;
